import React from 'react';

const STATUS_VARIANT = {
  draft:       'default',
  active:      'primary',
  completed:   'success',
  archived:    'default',
  pending:     'warning',
  ready:       'success',
  generating:  'warning',
  processing:  'warning',
  error:       'error',
  approved:    'success',
  rejected:    'error',
  ai_checked:  'info',
  reviewed:    'info',
  easy:        'success',
  medium:      'warning',
  hard:        'error',
  midterm:     'primary',
  end_semester:'primary',
  internal:    'info',
  quiz:        'info',
  theory:      'default',
  practical:   'info',
  viva:        'info',
};

export default function ExamBadge({ label, variant, status, dot = false, className }) {
  const v = variant || STATUS_VARIANT[status] || STATUS_VARIANT[label?.toLowerCase()] || 'default';
  const display = label || status || '';
  const classes = ['exam-badge', `exam-badge-${v}`, className].filter(Boolean).join(' ');
  return (
    <span className={classes}>
      {dot && <span className="exam-badge-dot" />}
      {display}
    </span>
  );
}
